import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import { ImageBlock } from '../../components/images/Images';
import { Section } from '../../layout/section/Section';
import {
    Paragraph,
    TextBlock,
    TitleH2,
} from '../../components/textBlock/TextBlock';

import ThumbImg2 from '../../images/gfx/2.png';
import ThumbImg3 from '../../images/gfx/3.png';
import Frameworks from '../../images/gfx/ESG-UN-SGD.png';
import Begin from '../../images/gfx/Begin.png';
import Collect from '../../images/gfx/Collect.png';
import Analyse from '../../images/gfx/Analyse.png';
import BeginResponsive from '../../images/gfx/Begin_responsive.png';
import CollectResponsive from '../../images/gfx/Collect_responsive.png';
import AnalyseResponsive from '../../images/gfx/Analyse_responsive.png';
import Strategy from '../../images/gfx/Strategy.png';

import { CheckedCircle } from '../../components/styledList/StyledList';
import {
    Frameworks1,
    Frameworks2,
    Frameworks3,
    Strategy1,
    Strategy2,
    Strategy3,
    Strategy4,
} from './FeatureData';
import { FeatureThereeList4 } from './FeatureData';
import { FeatureThereeList5 } from './FeatureData';
import { FeatureThereeList6 } from './FeatureData';

const getColorBandFromScore = (score) => {
    if (score < 34) {
        return 'danger';
    } else if (score < 68) {
        return 'warning';
    } else {
        return 'success';
    }
};

const FeatureThree = (props) => {
    return (
        <Section
            className={props.className && props.className}
            id={props.id && props.id}
            style={props.style}
        >
            <Container>
                <Row className="g-gs justify-content-between align-items-center">
                    <TextBlock>
                        <TitleH2 className="mb-3">
                            {props.title}&nbsp;
                            <span
                                className={`badge badge-md badge-${getColorBandFromScore(
                                    props.score
                                )}`}
                            >
                                <strong>{props.score}%</strong>
                            </span>
                        </TitleH2>
                    </TextBlock>
                </Row>
                <br />
                Whether you have a diversity strategy or not, by the end of this
                report you will have the blueprint for a solid strategy. <br />
                <br />
                First, let's design a data strategy that serves its purpose.
                <br />
                <br />
                <Row className="g-gs justify-content-between align-items-center">
                    <Col lg="4">
                        <ImageBlock>
                            <img
                                src={Begin}
                                className="thumb-img d-none d-lg-block"
                                alt="Begin with the end in mind"
                            />
                            <img
                                src={BeginResponsive}
                                className="thumb-img d-lg-none"
                                alt="Begin with the end in mind"
                            />
                        </ImageBlock>
                    </Col>
                    <Col lg="8">
                        <TextBlock>
                            <CheckedCircle
                                className="list-lg list-purple list-checked-circle pt-1"
                                data={FeatureThereeList4}
                            />
                        </TextBlock>
                    </Col>
                </Row>
                <br />
                <br />
                <Row className="g-gs justify-content-between align-items-center">
                    <Col lg="4" className="d-lg-none">
                        <ImageBlock>
                            <img
                                src={CollectResponsive}
                                alt="Collect the right data in the right matter"
                            />
                        </ImageBlock>
                    </Col>
                    <Col lg="8">
                        <TextBlock>
                            <CheckedCircle
                                className="list-lg list-purple list-checked-circle pt-1"
                                data={FeatureThereeList5}
                            />
                        </TextBlock>
                    </Col>
                    <Col lg="4" className="d-none d-lg-block">
                        <ImageBlock>
                            <img
                                src={Collect}
                                alt="Collect the right data in the right matter"
                            />
                        </ImageBlock>
                    </Col>
                </Row>
                <br />
                <br />
                <Row className="g-gs justify-content-between align-items-center">
                    <Col lg="4">
                        <ImageBlock>
                            <img
                                src={Analyse}
                                className="thumb-img d-none d-lg-block"
                                alt="Analyse your data intelligently"
                            />
                            <img
                                src={AnalyseResponsive}
                                className="thumb-img d-lg-none"
                                alt="Analyse your data intelligently"
                            />
                        </ImageBlock>
                    </Col>
                    <Col lg="8">
                        <TextBlock>
                            <CheckedCircle
                                className="list-lg list-purple list-checked-circle pt-1"
                                data={FeatureThereeList6}
                            />
                        </TextBlock>
                    </Col>
                </Row>
            </Container>
        </Section>
    );
};

const FeatureThreeAlt = (props) => {
    return (
        <Section
            className={props.className && props.className}
            id={props.id && props.id}
            style={props.style}
        >
            <Container>
                <Row className="g-gs flex-row-reverse justify-content-between align-items-center">
                    <ImageBlock>
                        <img src={ThumbImg2} alt="thumb-img" />
                    </ImageBlock>

                    <TextBlock>
                        <TitleH2 className="mb-3">
                            {props.title}&nbsp;
                            <span
                                className={`badge badge-md badge-${getColorBandFromScore(
                                    props.score
                                )}`}
                            >
                                <strong>{props.score}%</strong>
                            </span>
                        </TitleH2>
                        Having a diversity framework of your own is a good
                        start, as there's currently no unified framework to
                        measure and report your DE&amp;I impact. That said,
                        there are some frameworks that are generally accepted
                        and closer to standardisation.
                        <br />
                        <br />
                        <Row className="g-gs justify-content-between align-items-center">
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <ImageBlock className="text-center">
                                    <br />
                                    <img src={Frameworks} alt="thumb-img" />
                                </ImageBlock>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                        <Row className="g-gs justify-content-between align-items-center">
                            <Col lg="12">
                                <Paragraph>
                                    We have listed 15 main metrics from 3
                                    popular frameworks that can help you create
                                    a set of metrics for your industry and
                                    company.
                                </Paragraph>
                            </Col>
                            <Col lg="3">
                                <CheckedCircle
                                    className="list-lg list-purple list-checked-circle pt-1 small"
                                    data={Frameworks1}
                                />
                            </Col>
                            <Col lg="5">
                                <CheckedCircle
                                    className="list-lg list-purple list-checked-circle pt-1 small"
                                    data={Frameworks3}
                                />
                            </Col>
                            <Col lg="4">
                                <CheckedCircle
                                    className="list-lg list-purple list-checked-circle pt-1 small"
                                    data={Frameworks2}
                                />
                            </Col>
                        </Row>
                    </TextBlock>
                </Row>
            </Container>
        </Section>
    );
};

const FeatureThreethree = (props) => {
    return (
        <Section
            className={props.className && props.className}
            id={props.id && props.id}
            style={props.style}
        >
            <Container>
                <Row className="g-gs flex-row-reverse justify-content-between align-items-center">
                    <ImageBlock>
                        <img src={ThumbImg3} alt="thumb-img" />
                    </ImageBlock>
                    <TextBlock>
                        <TitleH2 className="mb-3">
                            {props.title}&nbsp;
                            <span
                                className={`badge badge-md badge-${getColorBandFromScore(
                                    props.score
                                )}`}
                            >
                                <strong>{props.score}%</strong>
                            </span>
                        </TitleH2>

                        <p>
                            Not quite there?...You're not alone, most companies
                            struggle to mature their DE&amp;I initiatives, and only
                            22% indicate they are at 'expert' or 'advanced' stages. 
                            <br></br>Here are a few action plans that
                            can help you complete your strategy
                        </p>
                        <br />
                        <Row className="g-gs justify-content-between align-items-center">
                            <Col lg="4">
                                <TextBlock>
                                    <CheckedCircle
                                        className="list-lg list-purple list-checked-circle pt-1 small"
                                        data={Strategy1}
                                    />
                                </TextBlock>
                                <br />
                                <br />
                                <TextBlock>
                                    <CheckedCircle
                                        className="list-lg list-purple list-checked-circle pt-1 small"
                                        data={Strategy4}
                                    />
                                </TextBlock>
                            </Col>
                            <Col lg="4">
                                <ImageBlock>
                                    <br />
                                    <br />
                                    <br />
                                    <img src={Strategy} alt="thumb-img" />
                                </ImageBlock>
                            </Col>
                            <Col lg="4">
                                <TextBlock>
                                    <CheckedCircle
                                        className="list-lg list-purple list-checked-circle pt-1 small"
                                        data={Strategy2}
                                    />
                                </TextBlock>
                                <br />
                                <br />
                                <br />
                                <TextBlock>
                                    <CheckedCircle
                                        className="list-lg list-purple list-checked-circle pt-1 small"
                                        data={Strategy3}
                                    />
                                </TextBlock>
                            </Col>
                        </Row>
                    </TextBlock>
                </Row>
            </Container>
        </Section>
    );
};

export { FeatureThree, FeatureThreeAlt, FeatureThreethree };
